import { useEffect, useState } from "react";

const footerNav = [
  { key: "ways", label: "获取方式" },
  { key: "hot", label: "热门资源" },
  { key: "category", label: "全部分类" },
  { key: "updates", label: "最新更新" },
  { key: "guide", label: "使用指南" },
  { key: "faq", label: "常见问题" },
];

const waysLink = ["网盘转存", "直链下载", "磁力链接", "秒传码"];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <footer className="bg-accent-900">
        <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-archive-drawer-line text-lg"></i>
                </span>
                <span className="font-heading text-lg font-bold text-background-50">宅宅资源库</span>
              </div>
              <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-50/70">
                汇总网盘、直链、磁力、秒传多种获取方式，热门资源提供打包下载，追更补档更省心。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50">站内导航</h4>
              <ul className="mt-4 grid grid-cols-2 gap-2">
                {footerNav.map((n) => (
                  <li key={n.key}>
                    <a
                      href={`#${n.key}`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollTo(n.key);
                      }}
                      className="text-sm text-background-50/70 transition-colors hover:text-background-50"
                    >
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50">获取方式</h4>
              <ul className="mt-4 space-y-2">
                {waysLink.map((w) => (
                  <li key={w} className="flex items-center gap-2 text-sm text-background-50/70">
                    <i className="ri-check-line text-accent-300"></i>
                    {w}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50">联系方式</h4>
              <ul className="mt-4 space-y-3 text-sm text-background-50/70">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-accent-300"></i>
                  <a href="mailto:hello@zhai-res.com" className="transition-colors hover:text-background-50">
                    hello@zhai-res.com
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-accent-300"></i>
                  每日更新 · 24h 补档反馈
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
            <p className="text-xs text-background-50/60">© 2026 宅宅资源库 · 资源仅供学习交流，请勿用于商业用途</p>
            <p className="text-xs text-background-50/60">网盘 · 直链 · 磁力 · 秒传 · 打包下载，一站搞定</p>
          </div>
        </div>
      </footer>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition-all hover:bg-primary-600 ${
          showTop ? "fade-in opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </>
  );
}